import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { ClipboardCheck } from "lucide-react";
import { AuditLogTable } from "@/components/audit/audit-log-table";
import { AuditLogDetailModal } from "@/components/audit/audit-log-detail-modal";
import { AuditLogFilters } from "@/components/audit/audit-log-filters";
import type { AuditLog } from "@/lib/types/inventory";

export const Route = createFileRoute("/_app/audit")({
  component: AuditPage,
});

function AuditPage() {
  const [selectedLog, setSelectedLog] = useState<AuditLog | null>(null);
  const [filters, setFilters] = useState<Record<string, string>>({});

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <ClipboardCheck className="h-6 w-6 text-primary" />
        <h1 className="text-2xl font-semibold text-foreground">Audit Log</h1>
      </div>

      <AuditLogFilters onFilterChange={setFilters} />

      <AuditLogTable onView={(log) => setSelectedLog(log)} filters={filters} />

      <AuditLogDetailModal
        log={selectedLog}
        open={!!selectedLog}
        onOpenChange={(open) => {
          if (!open) setSelectedLog(null);
        }}
      />
    </div>
  );
}
